import React from "react";
import styled from "styled-components";

const MetadataInput = ({
  value,
  onChange,
  error,
}: {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}) => (
  <Field>
    <label htmlFor="quest-metadata">Metadata (optional JSON)</label>
    <textarea
      id="quest-metadata"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      rows={6}
      spellCheck={false}
      aria-invalid={!!error}
      aria-describedby="quest-metadata-help"
    />
    <small id="quest-metadata-help" role={error ? "alert" : undefined}>
      {error ||
        "Use a JSON object to configure badge rules. Leave blank to clear metadata."}
    </small>
  </Field>
);

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  textarea {
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    font-family: monospace;
    resize: vertical;
  }
`;

export default MetadataInput;
